<div class="flex login-page">
  <div class="left-section">
    <div class="intro-title relative z-1"> Welcome to the Transportation Portal</div>
    <div class="intro-label relative z-1">{{signInDescription}}</div>
    <div class="login-banner-img">
      <img src="/assets/images/temp/login-img2.png" alt="">
    </div>
  </div>

  <div class="right-section scroll-bar-css">
      <div class="right-logo">
        <img src="/assets/images/temp/MI_black_logo.png" alt="" class="w-12rem">
      </div>
    <div class="signin-box-inner-container">
      <div class="col-12  sign-in-text" style="line-height: 2">
        <div class="lg:col-12 sign-in-content text-center welcome-back">
        Welcome Back</div>
        <div class="lg:col-12 justify-content-center">
          <div class="text-center">
          Login to manage your fleet, drivers, and bookings effortlessly
        </div>
      </div>
      </div>
      <div class="col-12">
        <div class="col-12 md:col-12 lg:col-12">
          <p-panel>
            <!-- <div class="form-field col-12 ">
              <div class="text-center"><img id="brand_logo" src="/assets/images/temp/MI_black_logo.png"></div>
              <div id="login_text" class="form-field col-12 switch-btn">Login</div>
            </div> -->
            <div id="sign-in-general-err" class="form-field col-12 p-0">
              <div class="form-errors alert alert-danger" [hidden]='!loginErrors[0]["general"]'>
                @for (ErrorMessage of loginErrors['general']; track ErrorMessage) {
                  <div id="login_error_message">
                    {{ErrorMessage.message}}
                  </div>
                }
              </div>
            </div>
            <div class="form-field col-12 p-0">
              <div class="form-errors alert alert-danger" [hidden]='!loginErrors[0]["email"]'>
                @for (ErrorMessage of loginErrors['email']; track ErrorMessage) {
                  <div id="login_error_email_message">
                    {{ErrorMessage.message}}
                  </div>
                }
              </div>
            </div>
            <app-login (signInEmitter)="doSignIn($event)" (forgotPasswordEmitter)="forgotPassword()"></app-login>

            <!-- <app-login (onSignInEmitter)="doSignIn($event)" (onForgotPasswordEmitter)="forgotPassword()"></app-login> -->
            <div style="clear: both;"></div>
          </p-panel>
        </div>
      </div>
      <div class="col-12 sign-in-text" style="text-align: center;position: fixed; bottom:20px;padding-bottom:0;width: 50%;">
        <a [href]="signInService.poweredByRedirectBeforeLoginUrl" target="_blank" style="font-size: 32px;" class="sign-in-content">
          <img id="mi_logo" [src]="signInService.poweredByBeforeLogoUrl" style="width: 3em;">
        </a>
      </div>
    </div>
  </div>
</div>


<!-- <div class="signin-box-container ">
  <div class="signin-box-inner-container">
   <div class="grid">
    <div class="logo-box col-12 md:col-6 lg:col-6">
      <div>
        <div class="form-field col-4">
          <img src='/assets/images/temp/mobisoft-final-logo.png'>
        </div>
        <div class="form-field col-12 sign-in-text-sm">
          <h2>{{signInWelcomeTextLabel}}</h2>
        </div>

        <div class="form-field col-11">
          <h4>{{signInDescription}}</h4>
        </div>
      </div>
    </div>

    <div class="signin-box col-12 md:col-5 lg:col-5">
      <p-panel class="p-panel1">
        <div class="form-field col-12">
          <div class="form-errors alert alert-danger" [hidden]='!loginErrors[0]["general"]'>
            <div *ngFor="let ErrorMessage of loginErrors['general']">
              {{ErrorMessage.message}}
            </div>
          </div>
        </div>
        <div class="form-field col-12">
          <div class="form-errors alert alert-danger" [hidden]='!loginErrors[0]["email"]'>
            <div *ngFor="let ErrorMessage of loginErrors['email']">
              {{ErrorMessage.message}}
            </div>
          </div>
        </div>

        <div class="form-field col-12">
          <div class="form-field col-12 switch-btn">Login</div>
          <div class="form-field col-12 selected-menu"></div>
        </div>

        <app-login (signInEmitter)="doSignIn($event)" (forgotPasswordEmitter)="forgotPassword()"></app-login>
        <div class="ui-helper-clearfix"></div>
      </p-panel>

    </div>
    </div>
  </div>
</div> -->


<p-dialog modal="true" styleClass="edit-popup extend-width" position="center center" responsive="true" [(visible)]="forgotPopup"
  [closable]="true" [header]="labelForgotPassword">
  <app-forgot-password (popClose)="popClose($event)" (popSave)="popSave($event)"></app-forgot-password>
</p-dialog>

<p-dialog modal="true" [style]="{'width': '500px'}" styleClass="edit-popup" position="center center" responsive="true" *ngIf="otpPopup" [(visible)]="otpPopup" [closable]="true" [header]="labelValidateOtp">
  <app-otp-verifiy [email]="otpEmail" [phone]="otpPhone" (otpPopClose)="otpPopClose($event)" (otpPopSave)="otpPopSave($event)"></app-otp-verifiy>
</p-dialog>

<p-dialog modal="true" [style]="{'width': '500px'}" styleClass="edit-popup" position="center center" responsive="true" [(visible)]="setPasswordPopup"
  [closable]="true" [header]="labelResetPassword">
  <app-set-password [otpId]="otpId" (setPasswordPopClose)="setPasswordPopClose($event)"></app-set-password>
</p-dialog>

